import {
  Box,
  Grid,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { useDispatch } from "react-redux";
import {
  getDefaultSurveyRoomAction,
  getSurveySetting,
  setUpdateDefaultSurveyRoomItemResponse,
  updatedSurveySettingResponse,
} from "../../../../store/reducers/settingSlice";
import { useSelector } from "react-redux";

import SurveyItemList from "./SurveyItemList";
import SurveyLinkedItem from "./SurveyLinkedItem";
import { getAllRoomListAction } from "../../../../store/reducers/leadSurveySlice";
import Notification from "../../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import SurveySettingForm from "./SurveySettingForm";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";

const MainSurveySettingPage = () => {
  const dispatch = useDispatch();
  const { leadDetails } = useSelector((state: any) => state.lead);
  const [value, setValue] = useState("0");
  const [pendingTab, setPendingTab] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const { surveySettingResponse,updateSurveyRoomItemResponse, defaultSurveyRooms, isSurveySettingResponse } =
    useSelector((state: any) => state?.setting);

  useEffect(() => {
    dispatch(getSurveySetting());
    dispatch(getDefaultSurveyRoomAction());
  }, [dispatch]);

  useEffect(() => {
    if (isSurveySettingResponse || updateSurveyRoomItemResponse) {
      dispatch(getSurveySetting());
      dispatch(updatedSurveySettingResponse(false));
      dispatch(setUpdateDefaultSurveyRoomItemResponse(false));
    }
  }, [isSurveySettingResponse,updateSurveyRoomItemResponse]);

  useEffect(() => {
    dispatch(getAllRoomListAction(leadDetails?.lead?.generated_id ?? "1111"));
  }, [dispatch, leadDetails]);

  // Intercept tab change
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    if (isDirty) {
      setPendingTab(newValue);
      setShowModal(true);
    } else {
      setValue(newValue);
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  };

  // Handle modal actions
  const handleModalYes = () => {
    setShowModal(false);
    setIsDirty(false);
    if (pendingTab !== null) {
      setValue(pendingTab);
      dispatch(setNotificationAction({ message: [], severity: "error" }));
      setPendingTab(null);
    }
  };
  const handleModalNo = () => {
    setShowModal(false);
    setPendingTab(null);
  };

  return (
    <>
      <Grid
        container
        rowSpacing={1}
        sx={{
          background: "#f4f4f4",
          height: "auto",
          padding: "10px",
        }}
      >
        <Box
          sx={{
            bgcolor: "#fff",
            padding: "20px 0px",
            border: "1px solid #d1cfcf",
            borderRadius: "5px",
            height: "fit-content",
            width: "100%",
          }}
        >
          <PageTitle title="Survey Setting" />

          <Grid
            container
            spacing={2}
            sx={{
              flexDirection: { xs: "column", md: "row" },
              marginTop: "10px",
              padding: "16px 20px",
            }}
          >
            <Notification />
            <Grid
              item
              xs={12}
              md={12}
              style={{ padding: "0px 10px", marginBottom: "10px" }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
                variant="standard"
                sx={{
                  background: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  marginBottom: "16px",
                }}
              >
                <Tab value="0" label="Booking Team & Time Slots" />
                <Tab value="1" label="Survey Areas & Items" />
                <Tab value="2" label="Survey Move Equipment" />
              </Tabs>
            </Grid>

            <Grid item xs={12}>
              {value === "0" && (
                <SurveySettingForm setDirty={setIsDirty} isDirty={isDirty} />
              )}
              {value === "1" && (
                <SurveyItemList
                  surveyRoomList={defaultSurveyRooms}
                  setDirty={setIsDirty}
                  isDirty={isDirty}
                />
              )}
              {value === "2" && (
                <SurveyLinkedItem setDirty={setIsDirty} isDirty={isDirty} />
              )}
            </Grid>
          </Grid>
          {/* Alert Modal */}
          {showModal && (
            <AlertPopup
              open={showModal}
              title="Unsaved Changes"
              content="You have unsaved changes. Do you want to leave without saving?"
              submitHandler={handleModalYes}
              onHide={handleModalNo}
            />
          )}
        </Box>
      </Grid>
    </>
  );
};

export default MainSurveySettingPage;
